var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Layout, Dependencies } from "~/core/decorator";
import DataForm from "~/components/common/data-form.vue";
import DataBox from "~/components/common/data-box.vue";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { SocialSecurityDataService } from "~/services/repair-service/social-security-data.service";
import AddSocialSecurityData from "~/components/data-repair/social-security-data/add-social-security-data.vue";
import EditSocialSecurityData from "~/components/data-repair/social-security-data/edit-social-security-data.vue";
import RepairDataImport from "~/components/data-repair/repair-data-import.vue";
import SocialSecurityDetail from "~/components/data-repair/social-security-data/social-security-detail.vue";
import { UploadFileService } from "~/services/common-service/upload-file.service";
import { DataRepairImportService } from "~/services/repair-service/data-repair-import.service";
import ImportBatchDeletion from "~/components/data-repair/census-data/import-batch-deletion.vue";
import { dataRepair } from "~/config/enum.config";
//@Auth(105)
var SocialSecurityData = /** @class */ (function (_super) {
    __extends(SocialSecurityData, _super);
    function SocialSecurityData() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rowData = {};
        _this.loading = {
            state: false
        };
        _this.importType = "SOCIAL_SECURITY"; //社保信息
        _this.censusModel = {};
        _this.editModel = {};
        _this.dataSet = [];
        _this.currentType = dataRepair;
        _this.kosekiModel = {
            id: "",
            name: "",
            idNo: "",
            bank: "",
            koseki: "",
            applyTransferArea: "",
            flag: "",
            applyFileContent: ""
        };
        _this.data = {};
        _this.dialog = {
            detail: false,
            edit: false,
            import: false,
            deletion: false
        };
        return _this;
    }
    SocialSecurityData.prototype.created = function () { };
    SocialSecurityData.prototype.mounted = function () {
        this.refreshData();
    };
    /**
     * keep-alive生命周期钩子函数
     */
    SocialSecurityData.prototype.activated = function () {
        // 加载数据
        this.refreshData();
    };
    SocialSecurityData.prototype.cancelData = function () {
        this.dialog.import = false;
        this.kosekiModel.flag = null;
    };
    /**
     * 查询户籍数据
     */
    SocialSecurityData.prototype.refreshData = function () {
        var _this = this;
        this.loading.state = true;
        this.socialSecurityDataService
            .search(this.kosekiModel, this.pageService, this.sortService, this.loading)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    //添加户籍弹窗
    SocialSecurityData.prototype.addClick = function () {
        this.dialog.detail = true;
    };
    SocialSecurityData.prototype.dataImpClick = function () {
        this.dialog.import = true;
    };
    SocialSecurityData.prototype.dataImportClick = function () {
        this.dialog.import = true;
        this.kosekiModel.flag = "1";
    };
    /**
     * 查看社保详情
     */
    SocialSecurityData.prototype.viewDetails = function (row) {
        this.rowData = row;
        this.dialog.social = true;
    };
    /**
     * 删除户籍数据
     */
    SocialSecurityData.prototype.deleteKoseki = function (scope) {
        var _this = this;
        this.$confirm("您确定要删除吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        })
            .then(function () {
            _this.loading.state = true;
            _this.socialSecurityDataService
                .delete(scope.row, _this.loading)
                .subscribe(function (data) {
                _this.$message.success("操作成功");
                _this.refreshData();
            });
        }, function (err) {
            _this.$message.error(err.msg);
        })
            .catch(function () {
            _this.$message({
                type: "info",
                message: "已取消删除"
            });
        });
    };
    /**
     * 修改户籍弹框
     */
    SocialSecurityData.prototype.editKoseki = function (scope) {
        this.editModel = scope.row;
        this.dialog.edit = true;
    };
    /**
     * 获取下载模板
     */
    SocialSecurityData.prototype.downLoadTemplate = function () {
        var _this = this;
        this.kosekiModel.applyFileContent = this.importType;
        this.dataRepairImportService
            .getSystemTemplate(this.kosekiModel, this.loading)
            .subscribe(function (data) {
            if (data) {
                _this.uploadFileService
                    .getFileStreamById(data.value)
                    .subscribe(function () { return _this.$message.success("下载成功"); });
            }
        }, function (_a) {
            var msg = _a.msg;
        });
        this.kosekiModel.applyFileContent = null;
    };
    SocialSecurityData.prototype.importBatchDeletion = function () {
        this.dialog.deletion = true;
    };
    __decorate([
        Dependencies(PageService)
    ], SocialSecurityData.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], SocialSecurityData.prototype, "sortService", void 0);
    __decorate([
        Dependencies(SocialSecurityDataService)
    ], SocialSecurityData.prototype, "socialSecurityDataService", void 0);
    __decorate([
        Dependencies(UploadFileService)
    ], SocialSecurityData.prototype, "uploadFileService", void 0);
    __decorate([
        Dependencies(DataRepairImportService)
    ], SocialSecurityData.prototype, "dataRepairImportService", void 0);
    SocialSecurityData = __decorate([
        Layout("workspace"),
        Component({
            components: {
                DataForm: DataForm,
                DataBox: DataBox,
                AddSocialSecurityData: AddSocialSecurityData,
                EditSocialSecurityData: EditSocialSecurityData,
                SocialSecurityDetail: SocialSecurityDetail,
                RepairDataImport: RepairDataImport,
                ImportBatchDeletion: ImportBatchDeletion
            }
        })
    ], SocialSecurityData);
    return SocialSecurityData;
}(Vue));
export default SocialSecurityData;
